import axios from "axios"

const fetchSingleCategoryRequest = () => {
	return {type: "FETCH_SINGLE_CATEGORY_REQUEST"}
}

const fetchSingleCategorySuccess = (category) => {
	return {type: "FETCH_SINGLE_CATEGORY_SUCCESS", payload: category}
}

const fetchSingleCategoryFailure = (error) => {
	return {type: "FETCH_SINGLE_CATEGORY_FAILURE", payload: error}
}

export const fetchSingleCategory = (id) => {
	return (dispatch) => {
		dispatch(fetchSingleCategoryRequest())
		axios.get(`p/category/${id}`)
		.then(response => {
			const category = response.data
			dispatch(fetchSingleCategorySuccess(category))	
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchSingleCategoryFailure(error))	
		})
	}
}